module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agent-info-form "
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getIndex) + "\n        "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasDelBtnShow),
      expression: "hasDelBtnShow"
    }],
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.deletefn(_vm.myIndex)
      }
    }
  }, [_vm._v("删除")])], 1), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.agentInfo,
      "rules": _vm.rules,
      "label-width": "84px"
    }
  }, [_c('div', {
    staticClass: "child-title"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "v-com-form"
  }, [(_vm.isReadOnly) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideContractNumber && _vm.agentInfo.RebateLevel !== 1),
      expression: "!isHideContractNumber&&agentInfo.RebateLevel!==1"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同号",
      "required": _vm.isRequired || _vm.isCoopNumRequied
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.agentInfo.ContractNumber),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "ContractNumber", $$v)
      },
      expression: "agentInfo.ContractNumber"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "v-com-form"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit),
      expression: "isEdit"
    }],
    staticClass: "v-com-matter"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideAgentLevel),
      expression: "!isHideAgentLevel"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "签约项目",
      "required": ""
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeIntentProject
    },
    model: {
      value: (_vm.agentInfo.ProjectType),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "ProjectType", $$v)
      },
      expression: "agentInfo.ProjectType"
    }
  }, _vm._l((_vm.intetPorjectList), function(item) {
    return _c('el-radio-button', {
      attrs: {
        "name": "xyxm",
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideAgentLevel),
      expression: "!isHideAgentLevel"
    }],
    class: {
      'viewImgPos': _vm.cptInReadonlyCanUpdate_OpenClass
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理商级别",
      "required": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeAgentLevel
    },
    model: {
      value: (_vm.agentInfo.AgentLevel),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "AgentLevel", $$v)
      },
      expression: "agentInfo.AgentLevel"
    }
  }, _vm._l((_vm.DescriptionList), function(item, index) {
    return _c('el-radio', {
      attrs: {
        "label": item.key,
        "disabled": item.disabled
      }
    }, [_vm._v(_vm._s(item.value))])
  }))], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLevel),
      expression: "isLevel"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "销售订货单号",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.agentInfo.SaleOrderNum),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "SaleOrderNum", $$v)
      },
      expression: "agentInfo.SaleOrderNum"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZqw && _vm.isOnly),
      expression: "isZqw && isOnly"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "v-com-form"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit),
      expression: "isEdit"
    }],
    staticClass: "v-com-matter"
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理类型",
      "required": ""
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeAgentType
    },
    model: {
      value: (_vm.agentInfo.ProxyType),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "ProxyType", $$v)
      },
      expression: "agentInfo.ProxyType"
    }
  }, _vm._l((_vm.AgentTypes), function(item, index) {
    return _c('el-radio', {
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.value))])
  }))], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAgentTypeOne),
      expression: "isAgentTypeOne"
    }],
    attrs: {
      "label": "独家订货量"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.agentInfo.FirstGoodsNum),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "FirstGoodsNum", $$v)
      },
      expression: "agentInfo.FirstGoodsNum"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAgentTypeOne),
      expression: "isAgentTypeOne"
    }],
    attrs: {
      "label": "独家订货单价"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.agentInfo.FirstGoodsPrice),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "FirstGoodsPrice", $$v)
      },
      expression: "agentInfo.FirstGoodsPrice"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAgentTypeOne),
      expression: "isAgentTypeOne"
    }],
    attrs: {
      "label": "合同预付款"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.isMoneyDisable
    },
    model: {
      value: (_vm.agentInfo.ContractMoney),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "ContractMoney", $$v)
      },
      expression: "agentInfo.ContractMoney"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAgentTypeOne),
      expression: "!isAgentTypeOne"
    }],
    attrs: {
      "label": "设备预付款",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.isMoneyDisable
    },
    model: {
      value: (_vm.agentInfo.DevicePreMoney),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "DevicePreMoney", $$v)
      },
      expression: "agentInfo.DevicePreMoney"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "uclear",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideChoicePolice),
      expression: "!isHideChoicePolice"
    }],
    class: {
      'viewImgPos': _vm.cptInReadonlyCanUpdate_PolicyTypeName
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "v-com-form"
  }, [(_vm.isAdd) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择政策",
      "required": _vm.showPolicyRequire
    }
  }, [_c('div', {
    staticClass: "itemPosDv"
  }, [(_vm.setAndReadonlyPolice) ? _c('div', {
    staticClass: "itemMatter"
  }) : _vm._e(), _vm._v(" "), _c('el-radio-group', {
    on: {
      "change": _vm.changePolicy
    },
    model: {
      value: (_vm.agentInfo.PolicyType),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "PolicyType", $$v)
      },
      expression: "agentInfo.PolicyType"
    }
  }, _vm._l((_vm.choicePoliceList), function(item) {
    return _c('el-radio-button', {
      attrs: {
        "name": "policyRadioGroup",
        "label": item.key
      }
    }, [_vm._v(_vm._s(item.value))])
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAdd),
      expression: "!isAdd"
    }],
    staticStyle: {
      "color": "#20A0FF"
    }
  }, [_vm._v(" 提示：若代理商级别为试课，此项可先不填!")])], 1)])], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.agentInfo.PolicyType == 64 && _vm.agentInfo.ProjectType == 2),
      expression: "agentInfo.PolicyType==64&&agentInfo.ProjectType==2"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户等级",
      "required": _vm.showRebateLevel
    }
  }, [_c('div', {
    staticClass: "itemPosDv"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.agentInfo.RebateLevel),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "RebateLevel", $$v)
      },
      expression: "agentInfo.RebateLevel"
    }
  }, _vm._l((_vm.LevelTypes), function(item) {
    return _c('el-radio-button', {
      attrs: {
        "label": item.key
      }
    }, [_vm._v(_vm._s(item.value))])
  }))], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.agentInfo.RebateLevel == 1 && _vm.agentInfo.ProjectType == 2),
      expression: "agentInfo.RebateLevel==1&&agentInfo.ProjectType==2"
    }],
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "follow-endTime",
    attrs: {
      "label": "合作意向书",
      "required": ""
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.agentInfo.CooperateIntent), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadOnly),
        expression: "!isReadOnly"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delcoop_Drawing(index)
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    staticClass: "container",
    attrs: {
      "id": _vm.adcoop_container
    }
  }, [_c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.adcoop_button,
      "size": "small",
      "icon": "plus"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLevel),
      expression: "!isLevel"
    }],
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "span": 24
    }
  }, [_vm._l((_vm.areaList), function(item, index) {
    return _c('area-select', {
      ref: 'areaForm' + (index + 1),
      refInFor: true,
      attrs: {
        "myIndex": index + 1,
        "isReadOnly": _vm.isReadOnly,
        "value": item,
        "label": '签约区域' + (index + 1),
        "hasDelFn": true,
        "label-width": "90px",
        "required": "",
        "disabled": _vm.disabled,
        "areaIsHide": _vm.setComHide
      },
      on: {
        "change": function($event) {
          _vm.areaSelectChange(index)
        },
        "delAreafn": _vm.delAreafn
      }
    })
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    class: [{
      marginLeft: _vm.setComHide
    }, _vm.addAreaClass],
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.addArea
    }
  }, [_c('span', {
    staticClass: "fa fa-plus-square"
  }), _vm._v(" 添加其他区域")])], 2), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLevel),
      expression: "!isLevel"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "授权经销期限"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px",
      "prop": "StartTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.agentInfo.StartDate),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "StartDate", $$v)
      },
      expression: "agentInfo.StartDate"
    }
  }), _vm._v("   -\n                                    ")], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    staticClass: "follow-endTime",
    attrs: {
      "label-width": "0px",
      "prop": "EndDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.agentInfo.EndDate),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "EndDate", $$v)
      },
      expression: "agentInfo.EndDate"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.setComHide),
      expression: "!setComHide"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "权益金",
      "prop": "Bond",
      "required": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.agentInfo.Bond),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "Bond", $$v)
      },
      expression: "agentInfo.Bond"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowGkk || _vm.isLevel),
      expression: "!isShowGkk||isLevel"
    }],
    class: {
      'viewImgPos': _vm.cptInReadonlyCanUpdate_AgentLevel
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "required": _vm.isRequired,
      "label": "公开课"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.agentInfo.OpenClass),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "OpenClass", $$v)
      },
      expression: "agentInfo.OpenClass"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideContractNumber),
      expression: "!isHideContractNumber"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "委托打款人"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.agentInfo.AuthDepositHolder),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "AuthDepositHolder", $$v)
      },
      expression: "agentInfo.AuthDepositHolder"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideContractNumber),
      expression: "!isHideContractNumber"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "委托打款人身份证"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.agentInfo.AuthDepHolderIDNumber),
      callback: function($$v) {
        _vm.$set(_vm.agentInfo, "AuthDepHolderIDNumber", $$v)
      },
      expression: "agentInfo.AuthDepHolderIDNumber"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "follow-endTime",
    attrs: {
      "label": "委托打款人身份证"
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.agentInfo.AuthDepositHolder_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadOnly),
        expression: "!isReadOnly"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delAdh_Drawing(index)
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    staticClass: "container",
    attrs: {
      "id": _vm.adh_container
    }
  }, [_c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.adhbrowse_button,
      "size": "small",
      "icon": "plus"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLevel),
      expression: "isLevel"
    }],
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "follow-endTime",
    attrs: {
      "label": "体验零售订单",
      "required": ""
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.agentInfo.RetailOrderNums), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadOnly),
        expression: "!isReadOnly"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delOrderNum_Drawing(index)
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    staticClass: "container",
    attrs: {
      "id": _vm.OrderNum_container
    }
  }, [_c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.OrderNum_button,
      "size": "small",
      "icon": "plus"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "follow-endTime",
    attrs: {
      "label": "经销合同协议",
      "required": _vm.browseRequired
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.agentInfo.HNC_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadOnly),
        expression: "!isReadOnly"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delC_Drawing(index)
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    staticClass: "container",
    attrs: {
      "id": _vm.container
    }
  }, [_c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.browse_button,
      "size": "small",
      "icon": "plus"
    }
  })], 1)])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectDepartmentVisiable || _vm.imgViewVisiable),
      expression: "selectDepartmentVisiable || imgViewVisiable"
    }],
    staticClass: "agent-info-mask"
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "select-department",
    attrs: {
      "modal": false,
      "show-close": false,
      "title": "选择上级代理商"
    },
    model: {
      value: (_vm.selectDepartmentVisiable),
      callback: function($$v) {
        _vm.selectDepartmentVisiable = $$v
      },
      expression: "selectDepartmentVisiable"
    }
  }, [_c('tree', {
    attrs: {
      "message": _vm.departmentList
    },
    on: {
      "NodeClick": _vm.selectDepartment
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "img-view",
    attrs: {
      "size": "large",
      "modal": false,
      "show-close": true
    },
    model: {
      value: (_vm.imgViewVisiable),
      callback: function($$v) {
        _vm.imgViewVisiable = $$v
      },
      expression: "imgViewVisiable"
    }
  }, [_c('img', {
    staticClass: "show-img-css",
    attrs: {
      "src": _vm.imgViewSrc,
      "width": "100%",
      "height": "100%"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f867393!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/agent-info/index.vue
// module id = 1538
// module chunks = 1